import { onlyNumbers } from '@widergy/web-utils/lib/normalize';

import { appConfig } from '../config/customization';

export const normalizeAccount = value => {
  if (!value) {
    return value;
  }
  return onlyNumbers(value).slice(0, appConfig.ACCOUNT_LENGTH);
};
